// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2_FHj","menuItem_remove":"MenuItem_menuItem_remove__UCaEc","menuItem__chevron":"MenuItem_menuItem__chevron__1SlFj"};